import React, {useContext} from 'react';
import {innerStyle} from "../../../../../styles/pages/home/MaterialYouBaseStyle";
import {useHistory} from "react-router-dom";
import {AppContext} from "../../../../../App";
import {Avatar, Button, Paper, Slide, Typography, Zoom} from "@mui/material";
import logo from "../../../../../assets/v2/Logo-Orca.svg";
import {amber, green, indigo, red} from "@mui/material/colors";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import {setThemeType} from "../../../../../services/AppServices";
import NightsStayTwoToneIcon from "@mui/icons-material/NightsStayTwoTone";
import WbSunnyTwoToneIcon from "@mui/icons-material/WbSunnyTwoTone";

const ProfiloPage = () => {
	const classes = innerStyle();
	let history = useHistory();
	const appContext = useContext(AppContext);
	
	return (
        <React.Fragment>
            <main className={classes.main} style={{width: "100%"}}>
				<header style={{
					display: "flex",
					justifyContent: "center",
					paddingBottom: 28,
					paddingTop: 20,
				}}>
					<Avatar src={logo} variant="circular" className={classes.logo}/>
					<Typography variant={"h1"} component={"h1"} align={"center"}
					            style={{color: indigo["A700"]}}>
						<b>
							<span style={{color: red[500]}}>c</span>
							<span style={{color: amber[500]}}>e</span>
							<span style={{color: indigo["A700"]}}>a</span>
							<span style={{color: green[500]}}>n</span>
						</b>
					</Typography>
				</header>
				<Grid container spacing={4} component={"article"} style={{padding: 20}}>
					<Grid item xs={12}>
						<Slide direction={"up"} in={true} mountOnEnter unmountOnExit style={{transitionDelay: "200ms"}}>
							<Paper className={classes.paper}>
								<Zoom in={true} style={{transitionDelay: "800ms"}}>
									<IconButton
                                        className={classes.backButton}
                                        onClick={() => history.goBack()}
                                        size="large">
										<ArrowBackIosRoundedIcon fontSize="small"/>
									</IconButton>
								</Zoom>
								<Typography variant={"h4"} component={"h1"}
								            style={{paddingLeft: 6, display: "inline-block", verticalAlign: "bottom"}}>
									<b>Profilo</b>
								</Typography>
								<Typography variant={"subtitle2"} color={"textSecondary"} style={{paddingLeft: 6}}>
									Visualizza le tue informazione e modifica le tue preferenze
								</Typography>
								<div className={classes.flexStart} style={{height: 500}}>
									cambio tema, foto profilo, bio, ...
									{/*//todo rimuovere height*/}
								</div>
								<div className={classes.flexEnd}>
									<Button className={classes.button} style={{borderRadius: 22}} variant={"contained"} disableElevation
									        onClick={() => alert("Ok va bene, grazie ")}>
										<b>Crea evento</b>
									</Button>
								</div>
							</Paper>
						</Slide>
					</Grid>
					<Grid item xs={12}
					      style={{
						      display: "flex",
						      alignItems: "center",
						      alignContent: "center",
						      justifyContent: "center",
						      position: "relative"
					      }}>
						<Typography variant={"caption"} color={"textSecondary"} align={"center"}>
							Atlantis© 2022<br/>
							Atlantis S.p.A 2022-2027<br/>
							Via San Paolo 33, Torino, TO
						</Typography>
						
						<IconButton
                            style={{position: "absolute", right: 4, bottom: 4}}
                            onClick={() => setThemeType(appContext.state.theme.palette.mode === "light" ? "dark" : "light",
                                appContext.state.theme, appContext.dispatch)}
                            size="large">
							{appContext.state.theme.palette.mode === "light" ? <NightsStayTwoToneIcon/> : <WbSunnyTwoToneIcon/>}
						</IconButton>
					</Grid>
				</Grid>
			</main>
        </React.Fragment>
    );
}

export default React.memo(ProfiloPage);